<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Receive Transaction Details</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <button @click="print_jangad" class="btn btn-primary btn-sm shadow-md mr-2">
          <PrinterIcon class="w-4 h-4" /> Print
        </button>
      </div>
    </div>
    <div class="grid grid-cols-12 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">

        <!-- BEGIN: Input -->
        <div class="intro-y box" v-if="transaction_details != null">
          <div class="p-5">
            <div class="grid grid-cols-12 gap-x-5">
              <div class="col-span-4 xl:col-span-4">

                <div>
                  <label for="update-profile-form-6" class="form-label font-bold">Transaction No. :&nbsp;</label><label
                    for="update-profile-form-6" class="form-label"> {{ transaction_details.transaction_code }}</label>
                </div>
                <div class="mt-3">
                  <label for="update-profile-form-6" class="form-label font-bold">Receive Pieces : &nbsp;</label><label
                    for="update-profile-form-6" class="form-label"> {{ transaction_details.receive_pieces }}</label>
                </div>
                <div class="mt-3">
                  <label for="update-profile-form-6" class="form-label font-bold">Receive Weight : &nbsp;</label><label
                    for="update-profile-form-6" class="form-label"> {{ $h.myFloat(transaction_details.receive_weight) }}
                    (Ct)</label>
                </div>

              </div>
              <div class="col-span-4 xl:col-span-4">

                <div class="mt-3" v-if="transaction_details.creator">
                  <label for="update-profile-form-6" class="form-label font-bold">Received By : &nbsp;</label><label
                    for="update-profile-form-6" class="form-label"> {{ (transaction_details.creator.first_name + ' ' +
                      transaction_details.creator.last_name) }} (Ct)</label>
                </div>
                <div class="mt-3">
                  <label for="update-profile-form-6" class="form-label font-bold">Receive Date Time : &nbsp;</label><label
                    for="update-profile-form-6" class="form-label"> {{ transaction_details.created_time }}</label>
                </div>
                <div class="mt-3">
                  <label for="update-profile-form-6" class="form-label font-bold">Receive IP : &nbsp;</label><label
                    for="update-profile-form-6" class="form-label"> {{ transaction_details.receive_ip }}
                    </label>
                </div>
                <div class="mt-3">
                  <label for="update-profile-form-6" class="form-label font-bold">Status : &nbsp;</label>
                  <label for="update-profile-form-6" class="form-label">
                    <span v-if="transaction_details.status == 1" class="text-theme-11 font-bold">Received</span>
                    <span v-if="transaction_details.status == 2" class="text-theme-9 font-bold">Returned</span>
                    <span v-if="transaction_details.status == 3" class="text-theme-6 font-bold">Cancelled</span>
                  </label>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="intro-y box mt-10" v-if="transaction_details != null">
          <div class="col-span-12 xl:col-span-12">
            <div class="flex flex-col sm:flex-row items-center pt-5 pb-5 border-b border-gray-200 dark:border-dark-5">
              <h2 class="font-medium text-base mr-auto pl-5">Selected Packets</h2>
            </div>
            <div class="p-5">
              <div class="grid grid-cols-12 gap-x-5">
                <div class="col-span-12">
                  <table class="border w-full">
                    <tr class="sticky top-0 pl-5 pr-5 pb-2 mt-3" style="background-color:#fff;">

                      <td class="font-bold text-left">
                        <p>Sr. No</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Packet No</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Stock No</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Issue Weight</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Receive Weight</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Loss Weight</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Process</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Employee</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Bhav</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Majuri</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Issue</p>
                      </td>
                      <td class="font-bold text-center">
                        <p>Status</p>
                      </td>
                    </tr>

                    <tr class="border" v-for="(field, index) in transaction_packets" :key="index">
                      <td class="p-1 text-left">
                        <label class="p-2 mt-2">{{ index + 1 }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.packet_no }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.stock_no }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.issue_weight }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.receive_weight }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.weight_loss }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.process_name }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">({{ field.employee_code }}) {{ field.employee_name }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.karigar_bhav }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.karigar_majuri }}</label>
                      </td>
                      <td class="p-2 text-center">
                        <label class="p-2 mt-3">{{ field.issue_date }}</label>
                      </td>
                      <td class="p-2 text-left">
                        <label class="p-2 mt-3">
                          <span v-if="field.status == 1" class="text-theme-11 font-bold">In Process</span>
                          <span v-if="field.status == 2" class="text-theme-9 font-bold">Received</span>
                          <span v-if="field.status == 3" class="text-theme-6 font-bold">Cancelled</span>
                        </label>
                      </td>
                    </tr>
                  </table>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  reactive,
  ref
} from 'vue'
import {
  mapGetters,
  mapActions
} from 'vuex'

import {
  BASE_URL
} from '@/constants/config.js'
import axios from 'axios'
import datetime from 'vuejs-datetimepicker';
import {
  helper as $h
} from '@/utils/helper'
import moment from 'moment';
import FileDownload from "js-file-download";
import store from '@/store';
import {
  useRoute
} from 'vue-router';
// const router = useRouter();
// const route = useRoute();

export default defineComponent({
  components: {
    datetime
  },
  setup() {
    const user_details = computed(() => store.state.user.currentUser)
    const route = useRoute()
    const transaction_details = ref(null)
    const transaction_packets = ref()
    const swal = inject('$swal');


    const get_records = (id) => {
      const params = {
        trans_id: id
      };
      let promise = axios({
        url: "api/process/receive_item_details",
        method: "POST",
        params: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          if (data.status == 'error') {

            transaction_details.value = [];
            transaction_packets.value = [];

            swal("Error!", data.message, "error");
          } else {

            transaction_details.value = data.transaction;
            transaction_packets.value = data.items;
          }
        })
        .catch(_error => {

          transaction_details.value = [];
          transaction_packets.value = [];

          swal("Error!", data.message, "error");
        });
    }
    const print_jangad = () => {
      let url = BASE_URL + 'receive_prints/' + '?trans_id=' + route.params.id
      window.open(url, '_blank');
    }

    onMounted(() => {
      get_records(route.params.id)
    })

    return {
      transaction_details,
      transaction_packets,
      user_details,
      print_jangad,
    }
  }

})
</script>
